import { Box, Collapse, Typography, IconButton, TablePagination } from '@mui/material';
import { TableDestinationTitle } from '../../data/destination.table.title';
import lineLoader from '../../../../components/lineLoader/lineLoader';
import { ProvinceModel } from '../../model/destination.model';
const defaultStyle = { border: '1px solid #1A1A1A20', padding: 5, backgroundColor: '#EEEFF3' };
import DeleteIcon from '@mui/icons-material/Delete';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import {
  CustomAlertAction,
  CustomAlertState,
} from '../../../../alert/controller/custom.alert.controller';
import { CustomAlertType } from '../../../../alert/data/custom.alert.type';
import { CustomAlertIcons } from '../../../../alert/data/custom.alert.icon';
import { DestinationModalNames, DestinationChildrenModel } from '../../data/destination.model.child';
import { DestinationFilter, ProvinceUpdateModel } from '../../model/destination.model';

export interface DestinationTableController {
  list: ProvinceModel[];
  listCount: number;
  loading: boolean;
  page: number;
  pageRowAmount: number;
  onPageChange: (page: number, rows: number) => void;
  onFilterChange: (filter?: DestinationFilter | null) => void;
  onUpdateFormUpdate: (form: ProvinceUpdateModel | null) => void;
  onHandleModal: (modal?: DestinationChildrenModel | null) => void;
  getData: (startLoading?: boolean, filter?: DestinationFilter | null) => void;
  onDelete: (id: string) => void;
}

const DestinationTable = ({
  ctrl,
  alert,
  label,
}: {
  ctrl: DestinationTableController;
  alert: CustomAlertState & CustomAlertAction;
  label: string;
}) => {
  return (
    <Box sx={{ overflowX: 'auto' }}>
      <Collapse
        unmountOnExit
        orientation="vertical"
        in={ctrl.loading && ctrl.listCount > 0}
      >
        {lineLoader()}
      </Collapse>
      <Collapse
        unmountOnExit
        orientation="vertical"
        in={!ctrl.loading || ctrl.listCount > 0}
      >
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              {TableDestinationTitle?.map((col, index) => (
                <th key={index} style={{ ...defaultStyle, backgroundColor: '#E4E8F3' }}>
                  <Typography>{col.label}</Typography>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {ctrl.list?.map((item: ProvinceModel, index: number) => (
              <tr key={index}>
                <td style={{ ...defaultStyle, textAlign: 'center' }}>
                  <Typography>{index + 1 + ctrl.page * ctrl.pageRowAmount}</Typography>
                </td>
                <td style={{ ...defaultStyle, textAlign: 'center' }}>
                  <Typography>{item?.title_la ?? '*'}</Typography>
                </td>
                <td style={{ ...defaultStyle, textAlign: 'center', textWrap: 'wrap' }}>
                  <Typography>{item?.title_en}</Typography>
                </td>
                <td style={{ ...defaultStyle, textAlign: 'center' }}>
                  <Typography>{item?.description ?? '*'}</Typography>
                </td>
                <td style={{ ...defaultStyle, textAlign: 'center' }}>
                  <IconButton
                    onClick={() => {
                      ctrl.onUpdateFormUpdate({
                        id: item.uuid,
                        title_la: item.title_la,
                        title_en: item.title_en,
                        description: item.description,
                      });
                      ctrl.onHandleModal({ name: DestinationModalNames.UPDATE });
                    }}
                  >
                    <BorderColorIcon />
                  </IconButton>
                  <IconButton
                    onClick={() =>
                      alert.handleCustomAlert({
                        title: 'ລົບຂໍ້ມູນ',
                        message: 'ທ່ານຕ້ອງການລົບຂໍ້ມູນແທ້ບໍ ?',
                        type: CustomAlertType.WARNING,
                        icon: CustomAlertIcons.deleteConfirm,
                        negText: 'ກັບຄືນ',
                        posText: 'ຢືນຢັນ',
                        onPositive: () => {
                          ctrl.onDelete(item.uuid);
                          alert.handleCustomAlert(null);
                        },
                      })
                    }
                  >
                    <DeleteIcon />
                  </IconButton>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Collapse>
      <Box sx={{ display: 'flex', flexDirection: 'row', paddingRight: '20px', alignItems: 'center' }}>
        <Typography paddingLeft="20px">ທັງໝົດ {ctrl.listCount} ລາຍການ</Typography>
        <Box sx={{ flex: 1 }} />
        <TablePagination
          component="div"
          colSpan={3}
          rowsPerPageOptions={[10, 25, 50, 100]}
          count={ctrl.listCount}
          page={ctrl.page}
          onPageChange={(_, newPage) => {
            ctrl.onPageChange(newPage, ctrl.pageRowAmount);
            ctrl.getData(true, {
              skip: ctrl.pageRowAmount * newPage,
              take: ctrl.pageRowAmount,
            });
          }}
          rowsPerPage={ctrl.pageRowAmount ?? 10}
          onRowsPerPageChange={(e) => {
            const rows = Number.parseInt(e.target.value);
            ctrl.onPageChange(0, rows);
            ctrl.getData(true, { skip: 0, take: rows });
          }}
          labelRowsPerPage={`${label}ຕໍ່ໜ້າ`}
        />
      </Box>
    </Box>
  );
};

export default DestinationTable;
